import { render, staticRenderFns } from "./PromptMultiFactor.vue?vue&type=template&id=4fb6dd17&scoped=true&"
import script from "./PromptMultiFactor.vue?vue&type=script&lang=js&"
export * from "./PromptMultiFactor.vue?vue&type=script&lang=js&"
import style0 from "./PromptMultiFactor.vue?vue&type=style&index=0&id=4fb6dd17&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fb6dd17",
  null
  
)

export default component.exports